import classNames from 'classnames';
import { Spacer } from '../Spacer';

export interface TileRowSkeletonProps {
  small?: boolean;
  medium?: boolean;
}

export const TileRowSkeleton = ({ small, medium }: TileRowSkeletonProps) => {
  return (
    <div
      className={classNames(
        'flex items-center bg-ds-accent3-100 rounded-md px-8 py-3 animate-pulse',
        {
          'border border-ds-natural-150': !small && !medium,
        }
      )}
    >
      <div className="flex items-center">
        <div className="w-14 h-11 bg-ds-natural-50 rounded-md" />
        <Spacer amount={0.75} />
      </div>
      <div
        className={classNames('flex items-center', {
          'w-72': small,
          'w-80': !small,
        })}
      >
        <div className="w-40 h-3.5 bg-ds-natural-50 rounded-md" />
      </div>
      {!small && !medium && (
        <div className="flex items-center w-48">
          <div className="w-24 h-3.5 bg-ds-natural-50 rounded-md" />
        </div>
      )}
      {!small && (
        <>
          <div className="flex items-center">
            <div className="w-10 h-10 bg-ds-natural-50 rounded-full" />
            <Spacer amount={0.75} />
          </div>
          <div className="flex items-center w-56">
            <div className="w-24 h-3.5 bg-ds-natural-50 rounded-md" />
          </div>
        </>
      )}

      <div className="flex items-center">
        <div
          className={classNames(
            'h-3.5 bg-ds-natural-50 rounded-md',
            small ? 'w-32' : 'w-72'
          )}
        />
      </div>
    </div>
  );
};
